import PortalLogin from "@/portal/PortalLogin";
import { RoleRoute } from "@/portal/PortalAuth";
import GuestDashboard from "@/portal/GuestDashboard";
import ManagementDashboard from "@/portal/ManagementDashboard";
import HomeownerDashboard from "@/portal/HomeownerDashboard";

const STAFF = ["admin", "manager", "reservations", "housekeeping", "maintenance"];

export const GuestLogin = () => (
  <PortalLogin title="Guest Login" redirectTo="/guest/dashboard" allowedRoles={["guest"]} testidPrefix="guest" magicLink />
);
export const ManagementLogin = () => (
  <PortalLogin title="Management Login" redirectTo="/management/dashboard" allowedRoles={STAFF} testidPrefix="mgmt" />
);
export const HomeownerLogin = () => (
  <PortalLogin title="Homeowner Login" redirectTo="/homeowner/dashboard" allowedRoles={["homeowner"]} testidPrefix="ho" />
);

export const GuestProtected = () => (
  <RoleRoute allow={["guest"]} loginPath="/guest"><GuestDashboard /></RoleRoute>
);
export const ManagementProtected = () => (
  <RoleRoute allow={STAFF} loginPath="/management"><ManagementDashboard /></RoleRoute>
);
export const HomeownerProtected = () => (
  <RoleRoute allow={["homeowner"]} loginPath="/homeowner"><HomeownerDashboard /></RoleRoute>
);
